import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { MatchDetailsHeaderComponent } from './match-details-header';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MatchDetailsHeaderComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
  ],
  exports: [
    MatchDetailsHeaderComponent
  ]
})
export class MatchDetailsHeaderComponentModule {}



// WEBPACK FOOTER //
// ./src/components/match-details-header/match-details-header.module.ts